type Option = {
  label: string;
  value: string;
  suffix?: string;
};

export default function filterOptionsFromDocuments<V, T extends Option>(
  documents: V[],
  extractor: (doc: V) => T[],
  totalCounts?: Record<string, number>
) {
  const filterCount = new Map<string, number>();
  const filters = new Map<string, T>();

  for (const doc of documents) {
    const options = extractor(doc);
    for (const opt of options) {
      if (filters.has(opt.value)) {
        const existingOption = filters.get(opt.value)!;
        const nextCount = (filterCount.get(opt.value) ?? 0) + 1;
        const suffix = totalCounts?.[opt.value] ?? nextCount;
        filterCount.set(opt.value, nextCount);
        existingOption.suffix = `(${suffix})`;
      } else {
        const suffix = totalCounts?.[opt.value] ?? 1;
        filterCount.set(opt.value, 1);
        filters.set(opt.value, {
          ...opt,
          label: opt.label,
          value: opt.value,
          suffix: `(${suffix})`
        });
      }
    }
  }

  return Array.from(filters.values());
}
